import React from 'react';
import { Chip } from '@mui/material';

interface RedChipProps {
  label: string;
  variant?: 'filled' | 'outlined';
  size?: 'small' | 'medium';
}

const RedChip: React.FC<RedChipProps> = ({
  label,
  variant = 'outlined',
  size = 'small'
}) => {
  return (
    <Chip
      label={label}
      color="error"
      variant={variant}
      size={size}
    />
  );
};

export default RedChip;